import useStore from './_store';
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import global from '../../common/global';
import { colorBlock } from '../defaultSpacing';
import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
import util from '@/common/util.js';
import AttomDesc from '@/components/attom-desc.vue'

export default {
    _getUseStore: useStore,
    i18next: {
        ns: 'md-nbr-demographics',
    },
    asyncData: mapAsyncData(asyncData),
    data: function() {
        return {
            title: '',
            nbrInfo: null,
            ...colorBlock,
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            "isCensusSubdivision": store => store.page?.censusSubdivision || false,
            "siteId": "siteId"
        }),
        ...mapState({
            "showRaceModule": store => store.showRaceModule,
            "countryConfig": store => store.countryConfig,
            "nbrDemoGraphicsInfo": store => store.geoGraphic
        }),
        isShow() {
            return !(
                (this.countryConfig === 'canada' &&
                !this.isDemoInfoHasData &&
                !this.isDemoGenderHasData &&
                !this.isDemoEducationHasData &&
                !this.isAgeHasData &&
                !this.isRaceHasData &&
                !this.isAnnualIncomeHasData &&
                !this.isEmploymentHasData) || this.isCensusSubdivision
            )
        },
        isMobileSize() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobileSize ? this.mobileTopSpacing : this.topSpacing) +
                'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobileSize ? this.mobileBtmSpacing : this.btmSpacing) +
                'px'
            );
        },
        styleVar({ backgroundColor, reportColor }) {
            let params = {}
            backgroundColor && (params.backgroundColor = backgroundColor);
            reportColor && (params.reportColor = reportColor);
            return params;
        },
        
        isDemoInfoHasData() {
            // Population field data 
            return this.nbrDemoGraphicsInfo?.demographics;
        },
        isDemoGenderHasData() {
            return this.nbrDemoGraphicsInfo?.demographics?.gender;
        },
        isDemoEducationHasData() {
            return this.nbrDemoGraphicsInfo?.demographics?.education;
        },
        isAgeHasData() {
            return this.nbrDemoGraphicsInfo?.demographics?.age;
        },
        isRaceHasData() {
            return this.nbrDemoGraphicsInfo?.demographics?.race;
        },
        isAnnualIncomeHasData() {
            return this.nbrDemoGraphicsInfo?.demographics?.income;
        },
        isEmploymentHasData() {
            return this.nbrDemoGraphicsInfo?.demographics?.employment;
        },
        isAllModuleHasData() {
            return (
                this.isDemoInfoHasData ||
                this.isDemoGenderHasData ||
                this.isDemoEducationHasData ||
                this.isAgeHasData ||
                this.isRaceHasData ||
                this.isAnnualIncomeHasData ||
                this.isEmploymentHasData
            );
        }
    },
    watch: {
        showRaceModule() {
            this.$nextTick(() => {
                global.resize('trigger');
            });
        },
        isAllModuleHasData: {
            immediate: true,
            handler(val) {
                if (util.isSSRServer) {
                    return; 
                }
                window?.siteAppVm?.$EventBus.$emit('canadaDemographicsConfig', {
                    siteid: this.siteId,
                    flag: !!val
                });
            }
        }
    },
    afterAsyncData() {
        this.nbrInfo = this.nbrInfo || {};
        this.resetData();
        let graphics = this.nbrDemoGraphicsInfo.demographics
        if (graphics) {
            this.onLngNsLoaded('md-nbr-demographics').then(() => {
                this.setChartData(graphics);
            })
        }
    },
    methods: {
        resetData() {
            this.ageOptions = null;
            this.raceOptions = null;
            this.incomeOptions = null;
            this.employmentOptions = null;
        },
        setChartData(data) {
            // Concrete logic is written in Concrete Style Logic 
        },
    },
    components: {
        AttomDesc
    }
};
